var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"credential"},[_c('p',{staticClass:"has-text-weight-bold"},[_vm._v(" "+_vm._s(_vm.credential.institution)+" ")]),_c('p',[_vm._v(_vm._s(_vm.programSpecialty))]),_c('p',[_vm._v(_vm._s(_vm.$t('work.position_range', {start: _vm.start, end: _vm.end})))])])
}
var staticRenderFns = []

export { render, staticRenderFns }